<div [innerHtml]="question.question_prompt" class="panel panel--pledge">
</div>